import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, withRouter } from "react-router-dom";
import getSymbolFromCurrency from "currency-symbol-map";
import { useSelector } from "react-redux";
import ProgressBar from "./ProgressBar";

const CauseCard = (props) => {
  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState();
  const languages = useSelector((state) => state.main.availableLanguages);
  const cause = props.cause;

  useEffect(() => {
    setSelectedLang(languages[i18n.language]);
  }, [languages, i18n.language, selectedLang]);

  return (
    <Fragment>
      <div key={cause.id} className="col-xl-4 col-lg-6 mb-4">
        <div className="card card-stats saa_shadow">
          <h1 className="title">{t(cause.title)}</h1>
          <div className="img-wrap">
            <LazyLoadImage
              alt={t(cause.title)}
              src={cause.img_url}
              width="100%"
            />
          </div>
          <div className="info-wrap">
            <small className="desc">
              {t(cause.short_description).length > 116
                ? t(cause.short_description).substring(0, 116) + "..."
                : t(cause.short_description)}
            </small>
          </div>
          <ProgressBar
            valuenow={cause.target_progress}
            valuemin={0}
            valuemax={100}
            arialabel={t(cause.title)}
            id={cause.id}
            label={(selectedLang && selectedLang.direction === "rtl"
              ? "%" + cause.target_progress.toFixed(0)
              : cause.target_progress.toFixed(0) + "%"
            )
              .toString()
              .toArabicDigits(i18n.language)}
          />
          <div className="bottom-wrap">
            <Link
              to={`/${i18n.language}/cause/${cause.unique_title}`}
              className="btn btn-outline-primary btn-block"
            >
              {t("OPEN_CAUSES_DONATE_BTN_LABEL")}
            </Link>
          </div>
          <div className="stats-card__unit-stats clearfix">
            <div className="one-third">
              <div className="stat">
                {getSymbolFromCurrency(cause.currencies_code)}
                {cause.paid_so_far
                  ? cause.paid_so_far.toFixed(0).toString().toArabicDigits(i18n.language)
                  : (0).toString().toArabicDigits(i18n.language)}
              </div>
              <div className="stat-value">{t("OPEN_CAUSES_RAISED_LABEL")}</div>
            </div>

            <div className="one-third">
              <div className="stat">
                {cause.contributers.toString().toArabicDigits(i18n.language)}
              </div>
              <div className="stat-value">
                {t("OPEN_CAUSES_CONTRIBUTERS_LABEL")}
              </div>
            </div>

            <div className="one-third no-border">
              <div className="stat">
                {getSymbolFromCurrency(cause.currencies_code)}
                {cause.target.toString().toArabicDigits(i18n.language)}
              </div>
              <div className="stat-value">{t("OPEN_CAUSES_TARGET_LABEL")}</div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default withRouter(CauseCard);
